/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivateTokenRouteImport } from './routes/activate.$token'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppUsageRouteImport } from './routes/_app/usage'
import { Route as AppPaymentsRouteImport } from './routes/_app/payments'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminUsageIndexRouteImport } from './routes/_app/admin/usage/index'
import { Route as AppAdminSettingsIndexRouteImport } from './routes/_app/admin/settings/index'
import { Route as AppAdminPaymentsIndexRouteImport } from './routes/_app/admin/payments/index'
import { Route as AppAdminCustomersIndexRouteImport } from './routes/_app/admin/customers/index'
import { Route as AppAdminCredentialsIndexRouteImport } from './routes/_app/admin/credentials/index'
import { Route as AppAdminAuditIndexRouteImport } from './routes/_app/admin/audit/index'
import { Route as AppAdminAdminsIndexRouteImport } from './routes/_app/admin/admins/index'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateTokenRoute = ActivateTokenRouteImport.update({
  id: '/activate/$token',
  path: '/activate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppUsageRoute = AppUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsRoute = AppPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsageIndexRoute = AppAdminUsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsIndexRoute = AppAdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPaymentsIndexRoute = AppAdminPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCustomersIndexRoute = AppAdminCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCredentialsIndexRoute =
  AppAdminCredentialsIndexRouteImport.update({
    id: '/credentials/',
    path: '/credentials/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminAuditIndexRoute = AppAdminAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAdminsIndexRoute = AppAdminAdminsIndexRouteImport.update({
  id: '/admins/',
  path: '/admins/',
  getParentRoute: () => AppAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/payments': typeof AppPaymentsRoute
  '/usage': typeof AppUsageRoute
  '/login': typeof AuthLoginRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/admin/': typeof AppAdminIndexRoute
  '/admin/admins/': typeof AppAdminAdminsIndexRoute
  '/admin/audit/': typeof AppAdminAuditIndexRoute
  '/admin/credentials/': typeof AppAdminCredentialsIndexRoute
  '/admin/customers/': typeof AppAdminCustomersIndexRoute
  '/admin/payments/': typeof AppAdminPaymentsIndexRoute
  '/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/admin/usage/': typeof AppAdminUsageIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/dashboard': typeof AppDashboardRoute
  '/payments': typeof AppPaymentsRoute
  '/usage': typeof AppUsageRoute
  '/login': typeof AuthLoginRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/admin': typeof AppAdminIndexRoute
  '/admin/admins': typeof AppAdminAdminsIndexRoute
  '/admin/audit': typeof AppAdminAuditIndexRoute
  '/admin/credentials': typeof AppAdminCredentialsIndexRoute
  '/admin/customers': typeof AppAdminCustomersIndexRoute
  '/admin/payments': typeof AppAdminPaymentsIndexRoute
  '/admin/settings': typeof AppAdminSettingsIndexRoute
  '/admin/usage': typeof AppAdminUsageIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/payments': typeof AppPaymentsRoute
  '/_app/usage': typeof AppUsageRoute
  '/_auth/login': typeof AuthLoginRoute
  '/activate/$token': typeof ActivateTokenRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/admin/admins/': typeof AppAdminAdminsIndexRoute
  '/_app/admin/audit/': typeof AppAdminAuditIndexRoute
  '/_app/admin/credentials/': typeof AppAdminCredentialsIndexRoute
  '/_app/admin/customers/': typeof AppAdminCustomersIndexRoute
  '/_app/admin/payments/': typeof AppAdminPaymentsIndexRoute
  '/_app/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/_app/admin/usage/': typeof AppAdminUsageIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/admin'
    | '/dashboard'
    | '/payments'
    | '/usage'
    | '/login'
    | '/activate/$token'
    | '/admin/'
    | '/admin/admins/'
    | '/admin/audit/'
    | '/admin/credentials/'
    | '/admin/customers/'
    | '/admin/payments/'
    | '/admin/settings/'
    | '/admin/usage/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/dashboard'
    | '/payments'
    | '/usage'
    | '/login'
    | '/activate/$token'
    | '/admin'
    | '/admin/admins'
    | '/admin/audit'
    | '/admin/credentials'
    | '/admin/customers'
    | '/admin/payments'
    | '/admin/settings'
    | '/admin/usage'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/forbidden'
    | '/_app/admin'
    | '/_app/dashboard'
    | '/_app/payments'
    | '/_app/usage'
    | '/_auth/login'
    | '/activate/$token'
    | '/_app/admin/'
    | '/_app/admin/admins/'
    | '/_app/admin/audit/'
    | '/_app/admin/credentials/'
    | '/_app/admin/customers/'
    | '/_app/admin/payments/'
    | '/_app/admin/settings/'
    | '/_app/admin/usage/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  ActivateTokenRoute: typeof ActivateTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate/$token': {
      id: '/activate/$token'
      path: '/activate/$token'
      fullPath: '/activate/$token'
      preLoaderRoute: typeof ActivateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/usage': {
      id: '/_app/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AppUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments': {
      id: '/_app/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AppPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/usage/': {
      id: '/_app/admin/usage/'
      path: '/usage'
      fullPath: '/admin/usage/'
      preLoaderRoute: typeof AppAdminUsageIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings/': {
      id: '/_app/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AppAdminSettingsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/payments/': {
      id: '/_app/admin/payments/'
      path: '/payments'
      fullPath: '/admin/payments/'
      preLoaderRoute: typeof AppAdminPaymentsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/customers/': {
      id: '/_app/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers/'
      preLoaderRoute: typeof AppAdminCustomersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/credentials/': {
      id: '/_app/admin/credentials/'
      path: '/credentials'
      fullPath: '/admin/credentials/'
      preLoaderRoute: typeof AppAdminCredentialsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit/': {
      id: '/_app/admin/audit/'
      path: '/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AppAdminAuditIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/admins/': {
      id: '/_app/admin/admins/'
      path: '/admins'
      fullPath: '/admin/admins/'
      preLoaderRoute: typeof AppAdminAdminsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminAdminsIndexRoute: typeof AppAdminAdminsIndexRoute
  AppAdminAuditIndexRoute: typeof AppAdminAuditIndexRoute
  AppAdminCredentialsIndexRoute: typeof AppAdminCredentialsIndexRoute
  AppAdminCustomersIndexRoute: typeof AppAdminCustomersIndexRoute
  AppAdminPaymentsIndexRoute: typeof AppAdminPaymentsIndexRoute
  AppAdminSettingsIndexRoute: typeof AppAdminSettingsIndexRoute
  AppAdminUsageIndexRoute: typeof AppAdminUsageIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminAdminsIndexRoute: AppAdminAdminsIndexRoute,
  AppAdminAuditIndexRoute: AppAdminAuditIndexRoute,
  AppAdminCredentialsIndexRoute: AppAdminCredentialsIndexRoute,
  AppAdminCustomersIndexRoute: AppAdminCustomersIndexRoute,
  AppAdminPaymentsIndexRoute: AppAdminPaymentsIndexRoute,
  AppAdminSettingsIndexRoute: AppAdminSettingsIndexRoute,
  AppAdminUsageIndexRoute: AppAdminUsageIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppPaymentsRoute: typeof AppPaymentsRoute
  AppUsageRoute: typeof AppUsageRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppPaymentsRoute: AppPaymentsRoute,
  AppUsageRoute: AppUsageRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  ActivateTokenRoute: ActivateTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
